import { type z } from 'zod';

import { unitySearchParams } from '@@containers/Search/unitySearchParams';

export const rtElementListSearchParams = unitySearchParams.pick({ q: true, tenantIds: true });

export type RtElementListSearchParams = z.output<typeof rtElementListSearchParams>;
